/* @flow */

import {createAction} from 'redux-act';

import type {CompletedActionsReportDataRequestedAction} from './types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: $PropertyType<CompletedActionsReportDataRequestedAction, 'payload'>
) => CompletedActionsReportDataRequestedAction = createAction(
    'COMPLETED_ACTIONS_REPORT_DATA_REQUESTED'
);

export const updateReportChartData = createAction('COMPLETED_ACTIONS_REPORT_CHART_DATA_UPDATED');
export const failReportChartData = createAction('COMPLETED_ACTIONS_REPORT_CHART_DATA_FAILED');
